<template>
    <div class="main-container">
        <div class="w">
            <div class="CourseDetails_box">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/pcViews/index' }"
                        >首页</el-breadcrumb-item
                    >
                    <el-breadcrumb-item
                        class="item_now"
                        :to="{ path: '/pcViews/information?newsType=article' }"
                    >
                        行业新闻</el-breadcrumb-item
                    >
                </el-breadcrumb>
            </div>
            <div class="details_box bgWhite">
                <div class="details_title">
                    {{ details.title }}
                </div>
                <div class="details_news">
                    <div class="details_news_left">
                        <p>日期：{{ details.publishDate }}</p>
                        <p>信息来源：{{ details.source }}</p>
                        <!-- <p>浏览次数：{{ details.clickNum }}</p> -->
                    </div>
                </div>
                <div
                    class="details_content"
                    v-html="articleUnescapeHtml(details.content)"
                    :class="[{ big: size == 18 }, { small: size == 14 }]"
                ></div>
                <div class="page_news">
                    <p @click="enterDetails(preArticle.id)">
                        上一篇：{{ preArticle.title }}
                    </p>
                    <p @click="enterDetails(nextArticle.id)">
                        下一篇：{{ nextArticle.title }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { unescapeHTML } from "utils/validate";
import { getArticleDetails } from "api/article";
export default {
    computed: {
        //文章转义字符
        articleUnescapeHtml() {
            return function (content) {
                return unescapeHTML(content);
            };
        },
    },
    data() {
        return {
            size: 16,
            details: {},
            preArticle: {},
            nextArticle: {},
            articleId: "",
            beginFontSize: null,
        };
    },
    created() {
        this.articleId = this.$route.query.articleId;
        this.fetchData(this.articleId);
    },
    methods: {
        enterDetails(id) {
            if (id != "") {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.fetchData(id);
            }
        },
        fetchData(id) {
            getArticleDetails(id).then((res) => {
                if (res.success && res.errorCode === "2000") {
                    this.details = res.body.data.article;
                    this.preArticle = res.body.data.preArticle;
                    this.nextArticle = res.body.data.nextArticle;
                } else {
                    this.$message({
                        type: "danger",
                        message: res.msg,
                    });
                }
            });
        },
    },
};
</script>
<style>
.details_content img {
    max-width: 100%;
}
.details_content.small p {
    font-size: 14px 18px !important;
    line-height: 32px !important;
}
.details_content.big p {
    font-size: 20px !important;
}
.details_content p {
    color: #3b3b3b;
}
</style>
<style scoped>
.page_news p {
    line-height: 26px;
    cursor: pointer;
}
.page_news {
    margin: 26px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 62px;
    font-size: 16px;
    color: #3b3b3b;
}
.details_content {
    padding: 26px 0;
    border-bottom: dashed 1px #3b3b3b;
}
.details_news_right span {
    cursor: pointer;
    margin: 0 8px;
}
.details_news_right p {
    margin-right: 40px;
}
.details_news_right {
    display: flex;
}
.details_news_left p {
    margin-right: 40px;
}
.details_news_left {
    display: flex;
}
.details_news {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 82px;
    font-size: 14px;
    color: #3b3b3b;
    border-bottom: solid 5px #8f8f8f;
}
.details_title {
    line-height: 42px;
    font-size: 30px;
    font-weight: bold;
    color: #000;
    text-align: center;
}
.details_box {
    margin: 20px 0;
    padding: 14px 20px;
}
</style>
